export default __webpack_public_path__ + "static/media/BuyerSmartLogo_Lockup.8e407f23.png";